import { render } from "./ylyProductImage.vue?vue&type=template&id=4c68df0a&scoped=true"
import script from "./ylyProductImage.vue?vue&type=script&lang=js"
export * from "./ylyProductImage.vue?vue&type=script&lang=js"

import "./ylyProductImage.vue?vue&type=style&index=0&id=4c68df0a&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c68df0a"]])

export default __exports__